export default __webpack_public_path__ + "static/media/youtube-symbol 1.ed5daf28.svg";